import { Box } from '@mui/material'
import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import { ReadOnlyTextField } from '../../garvan-react/Components/ReadOnlyTextField'
import { useUserContext } from '../../Contexts/UserConfig'
import PageSection from '../../Constants&Theme/PageSection'
import { useVesselContext } from '../../Contexts/Modules/SampleModule/VesselModule'

function VesselHoldingSection() {
  const { vesselQuery } = useVesselContext()
  const { loginConfig } = useUserContext()
  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Holding Information'}>
        <ReadOnlyTextField
          label="Holding"
          value={
            getCodeSetLabelLookup(
              loginConfig,
              ['KV-Holdings'],
              typeof vesselQuery.data?.HoldingID === 'string' ?
                parseInt(vesselQuery.data?.HoldingID)
              : vesselQuery.data?.HoldingID,
            ) || ''
          }
          fullWidth
        />
      </PageSection>
    </Box>
  )
}

export default VesselHoldingSection
